import { Box, Button, Container, Typography } from "@mui/material";
import ConfettiExplosion from "react-confetti-explosion";
import { useNavigate } from "react-router-dom";
import { UserCompletedIcon } from "../../../../common/assets/icons/UserCompleted";
import { useAppContext } from "../../../../common/context/AppContext";
import { isBasicPlan } from "../../../../common/utils";
import { RoutePaths } from "../../../consts/enums";
import { useEffect } from "react";
import { FillingPercentsService } from "../../../../common/services/FillingPercentsService";
import { EventName, trackEvent } from "../../../../common/utils/helpers";

export const BuyerCompleted = () => {
  const { user } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    const percentage = FillingPercentsService.GetPercentageBuyer(
      user.buyerFull
    );

    if (percentage === 100) {
      trackEvent(EventName.COMPLETED_BUYER);
    }
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100%",
        width: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        backgroundColor: "common.blackBlue",
        backgroundImage: "url(/images/BiggerGradient.png)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top right",
      }}
    >
      <ConfettiExplosion width={1600} particleCount={250} />
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 10,
            marginBottom: 4,
            paddingX: 10,
            paddingY: 5,
            backgroundColor: "common.grayLighterOpacity",
            borderRadius: 2,
          }}
        >
          <UserCompletedIcon />
          <Typography
            sx={{
              marginTop: 3,
              marginBottom: 2,
              color: "white",
              fontWeight: 500,
              fontFamily: "Inter",
              fontSize: 24,
            }}
          >
            Your Professional Buyer profile has now been completed.
          </Typography>
          <Typography variant="body1" color="white">
            The last step before welcoming you to our rapidly growing Pro Buyer
            Member network is to pay the Foundy membership fee
          </Typography>
        </Box>
        <Button
          variant="roundgradient"
          onClick={() =>
            isBasicPlan(user)
              ? navigate(RoutePaths.PLANS)
              : navigate(RoutePaths.YOU_ACQUISITION)
          }
        >
          Save &amp; Continue
        </Button>
      </Container>
    </Box>
  );
};
